module.exports = __webpack_public_path__ + "img/20_58.7c034791.png";